var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA11YmenuHalfdonutChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14062 12.7869C2.14062 12.7869 2.14062 12.7869 2.14062 12.7869H1.01562C1.01562 8.31888 4.57119 4.67822 8.97996 4.67822C13.3887 4.67822 16.9443 8.31888 16.9443 12.7869H15.8193V12.7869L13.0829 12.7869V12.7584H12.546C12.546 10.7846 10.9459 9.18454 8.97214 9.18454C6.99834 9.18454 5.39826 10.7846 5.39826 12.7584H4.83576V12.7869H2.14062ZM2.22878 11.6619H4.40189C4.68202 10.49 5.40114 9.48872 6.37573 8.84141L5.11601 7.0241C3.60805 8.07999 2.53368 9.7373 2.22878 11.6619ZM8.97996 5.80322C12.3738 5.80322 15.2037 8.33271 15.7311 11.6619L13.5424 11.6619C13.0484 9.59566 11.1897 8.05954 8.97214 8.05954C8.41757 8.05954 7.88544 8.15561 7.39148 8.33202L6.09075 6.45554C6.9692 6.03685 7.94853 5.80322 8.97996 5.80322Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA11YmenuHalfdonutChart);
export default __webpack_public_path__ + "static/media/a11ymenu_halfdonut_chart.03c363f9deaad1e83eb41de2dad4b3dd.svg";
export { ForwardRef as ReactComponent };